export enum bulkExportStatusListEnum {
    ALL = "0|3|4|5|7|1|2|6|9|15|17",
    CANCELABLE = '0|3|5|7',
    DOWNLOADABLE = '1',
    ARCHIVABLE = '1|4',
    QUEUED = '0',
    IN_PROGRESS = '3|5',
    ARCHIVED = '2|6',
    ERROR_OR_INTERRUPTED ='4|7',
    CANCELLED ='9',
    OPEN = '1'
}